import React, { useEffect, useState } from 'react';
import { Logo } from './ui/Logo';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'How It Works',
    id: 'how-it-works'
  }, {
    name: 'Platform',
    id: 'platform'
  }, {
    name: 'Why Hubble',
    id: 'why-hubble'
  }, {
    name: 'Use Cases',
    id: 'use-cases'
  }, {
    name: 'Team',
    id: 'team'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-hubble-ink/90 backdrop-blur-md border-b border-hubble-border py-3' : 'bg-transparent py-5'}`} data-id="element-82">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-83">
        <Logo data-id="element-84" />

        <nav className="hidden md:flex items-center gap-8" data-id="element-85">
          {navLinks.map(link => <a key={link.id} href={`#${link.id}`} onClick={e => scrollToSection(e, link.id)} className="font-body text-sm text-hubble-paper/70 hover:text-hubble-paper transition-colors" data-id="element-86">
              {link.name}
            </a>)}
        </nav>

        <Button variant="primary" size="sm" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-87">
          Book Demo
        </Button>
      </div>
    </header>;
}